/* eslint-disable array-callback-return */
/* eslint-disable no-useless-concat */
import { useEffect, useState } from 'react';

import { Calendar } from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import { Helmet } from 'react-helmet';
import { StyledCalendar } from './style';

import Summary from './Summary';
import { useAllMeetupsQuery } from '../../helpers/SendEmailApi';


const options = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
};

const option = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};

const MeetUp = () => {


    const [date, setDate] = useState(new Date());
    const [selectedDate, setselectedDate] = useState('')
    const [startTime, setstartTime] = useState('')
    const [endTime, setendTime] = useState('')
    const [selectedTime, setselectedTime] = useState('')
    const [availableHours, setavailableHours] = useState([])

    const { data, refetch } = useAllMeetupsQuery()

    const tileDisabled = ({ activeStartDate, date, view }) => {

        return new Date(date).getTime() + (1000 * 60 * 60 * 24) < new Date().getTime()
    }

    const handleTimeSelect = (e) => {

        let value = e.target.textContent

        let startingTym = value.split('-')[0]
        let endingTym = value.split('-')[1]

        let firstPart = new Date(date)
        firstPart = firstPart.toDateString()

        let country = new Date()
        country = country.toString()
        let findCountry = country.split('GMT')[1]
        let start = firstPart + ` ${startingTym}` + ':00' + ` GMT${findCountry}`
        start = new Date(start)
        setstartTime(start)

        let end = firstPart + ` ${endingTym}` + ':00' + ` GMT${findCountry}`
        end = new Date(end)
        setendTime(end)

        const formattedDate = new Date(start).toLocaleString('en-US', options);
        const timezoneOffset = new Date(start).getTimezoneOffset() / 60;
        const gmt = timezoneOffset >= 0 ? `+${timezoneOffset}` : timezoneOffset;
        const formattedDateWithGMT = `${formattedDate}, GMT${gmt}`;
        setselectedTime(formattedDateWithGMT)

    }

    useEffect(() => {

        const formattedDate = new Date(date).toLocaleString('en-US', option);
        const timezoneOffset = new Date(date).getTimezoneOffset() / 60;
        const gmt = timezoneOffset >= 0 ? `+${timezoneOffset}` : timezoneOffset;
        const formattedDateWithGMT = `${formattedDate}, GMT${gmt}`;
        setselectedDate(formattedDateWithGMT)

        let calHours = [];

        let comingDay = new Date(date).toLocaleDateString()

        let presentDay = new Date().toLocaleDateString()

        const presentHours = new Date().getHours()
        let teacherHourStart = 0

        if (comingDay === presentDay) {

            if (teacherHourStart < presentHours) {
                teacherHourStart = presentHours
            }
        }

        for (let i = teacherHourStart; i <= 23; i++) {
            const hourStart = i.toString().padStart(2, '0');
            const hourEnd = ((i + 1) % 24).toString().padStart(2, '0');
            const timeSlot = `${hourStart}:00-${hourEnd}:00`;
            calHours.push(timeSlot);
        }

        if (data && data.data) {

            data.data.alreadyBooked.length && data.data.alreadyBooked.map((item => {

                if (date.toDateString() === new Date(item.date).toDateString()) {

                    item.hours.map((hour) => {

                        let x = new Date(hour.startTime).toTimeString()
                        let y = x.slice(0, 5)

                        let m = new Date(hour.endTime).toTimeString()
                        let t = m.slice(0, 5)

                        let fullTime = y + '-' + t

                        fullTime = fullTime.toString()
                        calHours = calHours.filter((item) => item !== fullTime)
                    })
                }

            }))
        }

        setavailableHours(calHours)

    }, [date, data])


    return (
        <div className="bg-gray-50 dark:bg-gray-900 transition-all duration-700">
            <Helmet >
                <title>CodeZone | MeetUp</title>
            </Helmet>

            <StyledCalendar>
                <div className='pt-[70px] md:pt-[80px]'>
                    <div className="max-w-screen-lg mx-auto py-5 md:py-10 px-4 md:flex justify-center items-center">
                        {!selectedTime ? (
                            <div className='grid grid-cols-1 md:grid-cols-3'>
                                <div className='col-span-2'>
                                    <Calendar
                                        onChange={setDate}
                                        tileClassName="content"
                                        className='mycal'
                                        tileDisabled={tileDisabled}
                                    />
                                </div>
                                <div className='bg-white shadow-md md:rounded-tr-[20px] p-3 rounded-br-[20px] rounded-bl-[20px] md:rounded-bl-[0px]'>
                                    <h1 className='font-bold text-center text-xs'>
                                        What time works best?
                                    </h1>
                                    <h6 className='text-[14px] text-center mt-1 text-gray-600'>
                                        {selectedDate}
                                    </h6>
                                    <div className='mt-3 space-y-3 max-h-[370px] overflow-y-auto'>
                                        {availableHours.length > 0 ? availableHours.map((item, i) => (

                                            <div key={i} className='border-2 border-yellow-500 bg-gray-50  rounded-md hover:bg-gray-100 hover:scale-95 cursor-pointer duration-700'>
                                                <h1 className='text-center text-gray-600 text-[14px] py-1' onClick={(e) => handleTimeSelect(e)}>
                                                    {item}
                                                </h1>
                                            </div>
                                        )) : (
                                            <h2 className='text-center text-[12px] text-gray-500 underline underline-offset-4'>
                                                No, time is avaiable on this day.
                                            </h2>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Summary
                                selectedTime={selectedTime}
                                setselectedTime={setselectedTime}
                                startTime={startTime}
                                endTime={endTime}
                                refetch={refetch}
                            />
                        )}
                    </div>
                </div>
            </StyledCalendar>
        </div>
    )
}

export default MeetUp